import { LOAD_STATE } from '@shared/axios';
import { uuid4 } from '@shared/utils/uuid';
import { endOfDay, isAfter, startOfToday } from 'date-fns';
import { Ad } from './ad.types';

export const formatDataForAd = (campaignId, {
    data: {
        adName,
        startDate,
        endDate,
        adCreative: { mediaUrl, mediaName },
    },
}) => ({
    name: adName,
    campaignId,
    mediaName,
    mediaUrl,
    startDate,
    endDate: endOfDay(endDate),
});

export const formatAd = (response, state, action) => {
    const { requestAction } = action;
    const { id: remoteId } = response;
    const { data: ads } = state;

    return ads.map(ad => (ad.id === requestAction.referenceId
        ? {
            ...ad,
            remoteId,
            isCompleted: true,
            loadState: LOAD_STATE.SUCCESS,
        } : ad));
};

export const formatLoadAds = ads => ads.map((ad) => {
    const startDate = new Date(ad.startDate);
    const endDate = new Date(ad.endDate);
    const today = startOfToday();
    const isStartDateAfterToday = isAfter(startDate, today);

    return {
        id: ad.id,
        remoteId: ad.id,
        isCompleted: Boolean(isStartDateAfterToday),
        loadState: LOAD_STATE.SUCCESS,
        data: {
            adName: ad.name,
            startDate,
            endDate,
            adCreative: {
                mediaUrl: ad.mediaUrl,
                mediaName: ad.mediaName,
            },
        },
    };
});

export const formatErrorAd = (state, action) => {
    const { requestAction } = action;
    const ads = state.data;
    return ads.map(adData => (adData.id === requestAction.referenceId
        ? {
            ...adData,
            loadState: LOAD_STATE.FAIL,
            error: action.payload,
        } : adData));
};

export const duplicateNewAd = (ad: Ad) => ({
    ...ad,
    id: uuid4(),
    remoteId: null,
    isCompleted: false,
    loadState: LOAD_STATE.SUCCESS,
    data: {
        ...ad.data,
    },
});

export const updateNewAd = (previousAd, newAd) => ({
    ...previousAd,
    ...newAd,
});
